'use client';
import styled from 'styled-components';

export const StyledInterstitial = styled.form`
  position: relative;
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  @media ${props => props.theme.laptop} {
    justify-content: center;
    align-items: center;
    padding-left: 50%;
  }
`;

export const BackgroundImageContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  background-color: ${props => props.theme.colors.get(props.$backgroundColor)};

  /* Scrim keeps copy legible over the photo */
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: linear-gradient(
      180deg,
      transparent 35%,
      color-mix(
          in srgb,
          ${props => props.theme.colors.neutral.darkest} 55%,
          transparent
        )
        100%
    );

    @media ${props => props.theme.laptop} {
      background: linear-gradient(
        270deg,
        color-mix(
            in srgb,
            ${props => props.theme.colors.neutral.darkest} 50%,
            transparent
          )
          0%,
        transparent 55%
      );
    }
  }
`;

const imageWrapperStyles = `
  position: absolute;
  inset: 0;

  img {
    object-fit: cover;
  }
`;

export const MobileImageWrapper = styled.div`
  ${imageWrapperStyles}

  img {
    object-position: center top;
  }

  @media ${props => props.theme.laptop} {
    display: none;
  }
`;

export const DesktopImageWrapper = styled.div`
  display: none;
  ${imageWrapperStyles}

  img {
    object-position: left center;
  }

  @media ${props => props.theme.laptop} {
    display: block;
  }
`;

export const ArrowContainer = styled.div`
  display: flex;
  position: absolute;
  top: ${props => props.theme.spacing(10)};
  left: 10px;
  gap: ${props => props.theme.spacing(4)};
  z-index: 2;

  button {
    background-color: ${props =>
      props.theme.colors.get(
        props.$backButtonBackgroundColor || 'background.lightest',
      )};
    border-color: ${props =>
      props.theme.colors.get(
        props.$backButtonBackgroundColor || 'background.lightest',
      )};
  }
`;

export const ContentOverlay = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(4)};
  box-sizing: border-box;
  width: 100%;
  max-width: 345px;
  padding: ${props => props.theme.spacing(6, 5, 10)};
  text-align: center;
  align-items: center;

  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(10, 5)};
    text-align: left;
    align-items: flex-start;
  }
`;

export const Headline = styled.div`
  ${props => props.theme.typography.heading3};
  color: ${props =>
    props.theme.colors.get(props.$fontColor || 'text.lightest')};
  width: 100%;
`;

export const Subheadline = styled.div`
  width: 100%;

  p {
    ${props => props.theme.typography.heading5};
    color: ${props =>
      props.theme.colors.get(props.$fontColor || 'text.lightest')};
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(2)};
  width: 100%;

  /* Widget stack spacing is handled by gap, not per-item margin */
  > * {
    margin-block: 0;
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
`;
